import { useMemo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import type { ValueMap } from "../types";

type UseMultiselectFilterDisplayTextParams<K> = {
    defaultSelectionKey: string;
    isDefaultSelected: boolean;
    nonDefaultSelectionKey: string;
    selectedFilterData: ValueMap<K>;
};

export const useMultiselectFilterDisplayText = <K>({
    defaultSelectionKey,
    isDefaultSelected,
    nonDefaultSelectionKey,
    selectedFilterData,
}: UseMultiselectFilterDisplayTextParams<K>): string => {
    const { translate } = useTranslate();

    return useMemo(() => {
        if (isDefaultSelected) {
            return translate(defaultSelectionKey);
        }

        const [firstItem] = selectedFilterData.values();

        return translate(nonDefaultSelectionKey, {
            selection: selectedFilterData.size === 1 ? firstItem.label : selectedFilterData.size,
        });
    }, [isDefaultSelected, selectedFilterData, translate, defaultSelectionKey, nonDefaultSelectionKey]);
};
